import React from 'react'

export const Dot = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>((props, ref) => {

  const {
    className,
    ...rest
  } = props
  return <div ref={ref} className={`h-1 w-1 mr-[3px] bg-gray-600 rounded-full ${className}`} {...rest} />
})